import { collection, doc } from 'firebase/firestore';
import {
  nifsMatchDetailConverter,
  questionConverter,
  roundConverter,
  solutionConverter,
  tournamentConverter,
} from './converters';
import { db } from './firestore';

export const tournamentsCol = collection(db, 'tournaments').withConverter(
  tournamentConverter
);

export const tournamentRef = (tournamentId: string) =>
  doc(db, 'tournaments', tournamentId).withConverter(tournamentConverter);

export const roundsCol = collection(db, 'rounds').withConverter(roundConverter);

export const roundRef = (roundId: string) =>
  doc(db, 'rounds', roundId).withConverter(roundConverter);

export const questionsCol = collection(db, 'questions').withConverter(
  questionConverter
);

export const questionRef = (questionId: string) =>
  doc(db, 'questions', questionId).withConverter(questionConverter);

export const solutionsCol = collection(db, 'solutions').withConverter(
  solutionConverter
);

export const solutionRef = (questionId: string) =>
  doc(db, 'solutions', questionId).withConverter(solutionConverter);

export const nifsMatchDetailedRef = (nifsMatchId: string) =>
  doc(db, 'nifs-match-detailed', nifsMatchId).withConverter(
    nifsMatchDetailConverter
  );
